// extracted by css-extract-rspack-plugin
export default {"SegmentedControl":"BlobTabButtons-module__SegmentedControl__YDO7GlP"};